import { render, staticRenderFns } from "./Agree2.vue?vue&type=template&id=5ce98658&scoped=true&"
import script from "./Agree2.vue?vue&type=script&lang=js&"
export * from "./Agree2.vue?vue&type=script&lang=js&"
import style0 from "./Agree2.vue?vue&type=style&index=0&id=5ce98658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce98658",
  null
  
)

export default component.exports